import React, { useEffect, useState, useMemo, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { loadDropdownData } from "../../containers/distributorsSlice/distributorsSlice";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import localeDefaults from "./LocalesMapping";
import {cardsDefaultUrl} from '../../constants/index';

const Distributors = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const {
    regions = [],
    countries = [],
    brands = [],
    errorRegions,
    errorCountries,
    errorBrands,
    loaded,
    error,
  } = useSelector((state) => state.dropdown || {});

  const [selectedRegion, setSelectedRegion] = useState("");
  const [selectedBrand, setSelectedBrand] = useState("");
  const [selectedCountry, setSelectedCountry] = useState("");
  const [loadingRegions, setLoadingRegions] = useState(true);
  const [loadingCountries, setLoadingCountries] = useState(true);
  const [loadingBrands, setLoadingBrands] = useState(true);
  const [selectedReseller, setSelectedReseller] = useState("");
  const [regionClass, setRegionClass] = useState('');
  const allData = useSelector((state) => state.dropdown.allData || []);
  const location = useLocation();

  // Get "en-se" from "/en-se/distributors"
  const urlLocale = location.pathname.split("/")[1]?.toLowerCase();

  // Fallback to "en" if not matched
  const effectiveLocale = localeDefaults[urlLocale] ? urlLocale : "en"; // fallback

  useEffect(() => {
    // document.addEventListener("click",(e)=>{
    //   if(!document.body.classList.contains("disabledOutline")){
    //     // console.log(e.target);
    //     document.body.classList.add("disabledOutline");
    //   }
    // })
    // document.addEventListener("keyup",(e)=>{
    //   console.log(e.keyCode);
    //   if(document.body.classList.contains("disabledOutline")){
    //     // console.log(e.target);
    //     document.body.classList.remove("disabledOutline");
    //   }
    //   if(e.keyCode === 9 && !document.body.classList.contains("focusOutline")){
    //     // console.log(e.target);
    //     document.body.classList.remove("disabledOutline");
    //   }
    // })
    console.log("urllocale", urlLocale);
    if (loaded) {
      const defaults = localeDefaults[effectiveLocale];

      if (defaults) {
        if (!selectedRegion && regions.includes(defaults.region)) {
          setSelectedRegion(defaults.region);
        }
        if (!selectedCountry && countries.includes(defaults.country)) {
          setSelectedCountry(defaults.country);
        }
        if (!selectedBrand && brands.includes(defaults.brand)) {
          setSelectedBrand(defaults.brand);
        }
      }

      setLoadingRegions(false); // ✅ done loading
      setLoadingCountries(false);
      setLoadingBrands(false);
    }
  }, [loaded, effectiveLocale, regions, countries, brands]);

  const { selectedOption = "" } = useSelector((state) => state.radio);

  useEffect(() => {
    if (!loaded) {
      dispatch(loadDropdownData());
    }
  }, [dispatch, loaded]);

  // ✅ Auto-select preferred reseller
  const resellerTitles = useMemo(() => {
    if (!Array.isArray(allData)) return [];
    if (!selectedRegion && !selectedCountry && !selectedBrand) return [];
    const filtered = allData.filter((item) => {
      const matchRegion = selectedRegion
        ? item.Region?.Title?.trim().toLowerCase() ===
          selectedRegion.trim().toLowerCase()
        : true;

      const matchCountry = selectedCountry
        ? item.Country?.Title?.trim().toLowerCase() ===
          selectedCountry.trim().toLowerCase()
        : true;

      const matchBrand = selectedBrand
        ? Array.isArray(item.BrandName) &&
          item.BrandName.map((b) => b?.trim().toLowerCase()).includes(
            selectedBrand.trim().toLowerCase()
          )
        : true;

      return matchRegion && matchCountry && matchBrand;
    });

    const resellerTypes = [
      ...new Set(
        filtered.flatMap((item) =>
          Array.isArray(item.ResellerType)
            ? item.ResellerType.map((r) => r?.Title?.trim()).filter(Boolean)
            : []
        )
      ),
    ];

    return resellerTypes.sort((a, b) => a.localeCompare(b));
  }, [allData, selectedRegion, selectedCountry, selectedBrand]);

  // useEffect(() => {
  //   if (resellerTitles.length === 1) {
  //     if (selectedReseller !== resellerTitles[0]) {
  //       setSelectedReseller(resellerTitles[0]);
  //     }
  //   } else if (resellerTitles.length > 1) {
  //     const isCurrentValid = resellerTitles.includes(selectedReseller);
  //     if (!isCurrentValid) {
  //       const preferred =
  //         resellerTitles.find(
  //           (title) =>
  //             title === "Online Stores"
  //         ) || resellerTitles.find(
  //           (title) =>
  //             title === "Data Center Drives"
  //         ) || resellerTitles[0];

  //       if (selectedReseller !== preferred) {
  //         setSelectedReseller(preferred);
  //       }
  //     }
  //   } else {
  //     if (selectedReseller !== "") {
  //       setSelectedReseller("");
  //     }
  //   }
  // }, [resellerTitles, selectedReseller]);


  useEffect(() => {
    if (resellerTitles.length === 1) {
      // Only one option – select it
      setSelectedReseller(resellerTitles[0]);
    } else if (resellerTitles.length > 1) {
      // Multiple options – always prioritize "Online Stores" or "Data Center Drives"
      const preferred =
        resellerTitles.find(title => title === "Online Stores") ||
        resellerTitles.find(title => title === "Data Center Drives") ||
        resellerTitles[0];
  
      setSelectedReseller(preferred);
    } 
  }, [resellerTitles]);

  const filteredCountries = useMemo(() => {
    if (!Array.isArray(allData)) return [];

    const filtered = allData.filter((item) => {
      const matchRegion = selectedRegion
        ? item.Region?.Title?.toLowerCase() === selectedRegion.toLowerCase()
        : true;

      const matchBrand = selectedBrand
        ? item.BrandName?.some(
            (b) => b?.toLowerCase() === selectedBrand.toLowerCase()
          )
        : true;

      const hasReseller =
        Array.isArray(item.ResellerType) && item.ResellerType.length > 0;

      return matchRegion && matchBrand && hasReseller;
    });

    const uniqueCountries = [
      ...new Set(
        filtered.map((item) => item.Country?.Title?.trim()).filter(Boolean)
      ),
    ];

    return uniqueCountries.sort((a, b) => a.localeCompare(b));
  }, [allData, selectedRegion, selectedBrand]);

  // ✅ Final filtered results
  const filteredResults = useMemo(() => {
    if (!Array.isArray(allData)) return [];
    
    return allData
      .filter((item) => {
        const matchRegion = selectedRegion
          ? item.Region?.Title?.trim().toLowerCase() ===
            selectedRegion.trim().toLowerCase()
          : true;

        const matchBrand = selectedBrand
          ? Array.isArray(item.BrandName) &&
            item.BrandName.map((b) => b?.trim().toLowerCase()).includes(
              selectedBrand.trim().toLowerCase()
            )
          : true;

        const matchCountry = selectedCountry
          ? item.Country?.Title?.trim().toLowerCase() ===
            selectedCountry.trim().toLowerCase()
          : true;

        const matchReseller = selectedReseller
          ? Array.isArray(item.ResellerType) &&
            item.ResellerType.some(
              (r) =>
                r?.Title?.trim().toLowerCase() ===
                selectedReseller.trim().toLowerCase()
            )
          : true;

        return matchRegion && matchBrand && matchCountry && matchReseller;
      })
      .sort((a, b) =>
        (a.Title || "")
          .toString()
          .toLowerCase()
          .localeCompare((b.Title || "").toString().toLowerCase())
      );
  }, [
    allData,
    selectedRegion,
    selectedBrand,
    selectedCountry,
    selectedReseller,
  ]);

  // Add return JSX here (dropdowns, filters, results)

  return (
    <section className="sd-relative distributor" >
      {/* <div className="sd-press-release-container sd-container lg:sd-mt-[174px] sd-mt-[80px]"> */}
        <div className={`sd-bg-color sd-relative sd-grid lg:sd-grid-cols-12 sd-grid-cols-8 sd-pt-[5rem] sd-pb-[5rem] sd-pl-[1rem] sd-items-center sd-inline-flex sd-shrink-0`}>
          <div className="lg:sd-text-[56px] sd-text-[23px] sd-font-pilat lg:sd-col-span-7 xl:sd-col-span-7 2xl:sd-col-span-6 sd-col-span-7">
            <h1 className="sd-text-left sd-text-[2.25rem] lg:sd-text-[3rem] xl:sd-text-[4rem] sd-leading-[110%] sd-font-[500] sd-mb-4 sd-font-pilat sd-normal-case sd-whitespace-pre-line">
              <span className="xl:sd-block sd-hidden">{t("distributors").replace(/D/g, "\nD")}</span>
              <span className="xl:sd-hidden sd-block">{t("distributors")}</span>
            </h1>

            <p className="sd-text-left sd-text-[1rem] sm:sd-text-[1.5rem] sd-pl-[0.2rem] sd-tracking-[0] sd-font-[500] sd-leading-[120%]">
              {t("distdescription")}
            </p>
          </div>
      </div>

      {(urlLocale === "el-gr" ||
        urlLocale === "es-es" ||
        urlLocale === "fr-ca" ||
        urlLocale === "fr-fr" ||
        urlLocale === "it-it" ||
        urlLocale === "ja-jp" ||
        urlLocale === "nl-nl" ||
        urlLocale === "pl-pl" ||
        urlLocale === "de-de" ||
        urlLocale === "de-at" ||
        urlLocale === "cs-cz") && (
        <section className="sd-relative sd-py-10 sd-container">
          <div className="sd-subnav">
            <div className="sd-press-release-template ">
              <div className="sd-relative sd-subnav2-0">
                <div
                  id="sd-sticky-nav"
                  data-margin-top="50"
                  data-sticky-className="sticky-stuck"
                  className="sd-sticky-head sd-flex sd-justify-start sd-justify-start sd-bg-white sd-bottom-0 sd-text-black sd-left-0 sd-overflow-y-hidden sd-relative sd-w-full sd-z-10 sd-border-b sd-border-[#ebebeb]"
                  style={{ position: "relative", top: "0px" }}
                >
                  <div
                    className="sd-flex sd-inner-wrap sd-flex-col md:sd-flex-row md:sd-pr-4 sd-pr-0 sd-pl-4 md:sd-pl-0"
                    style={{ justifyContent: "start" }}
                  >
                    <div className="sd-pr-4 md:sd-mr-6 lg:sd-mr-12 sd-whitespace-no-wrap sd-subnav-item sd-active-subnav-item">
                      <a
                        href={t("storeurl")}
                        target="_self"
                        className="sd-link-cta sd-block sd-py-4 sd-text-sm sd-border-b-4 sd-border-[#e10600] sd-pb-[18px] sd-text-[#e10600]"
                      >
                        {t("storeTab")}
                      </a>
                    </div>

                    <div className="sd-pr-4 md:sd-mr-6 lg:sd-mr-12 sd-whitespace-no-wrap sd-subnav-item ">
                      <a
                        href={t("contactusurl")}
                        target="_self"
                        className="sd-link-cta sd-block sd-py-4 sd-text-sm"
                      >
                        {t("contactusTab")}
                      </a>
                      <div className="sd-slidingDiv"></div>
                    </div>
                  </div>
                </div>
              </div>
              <div style={{ clear: "both" }}></div>
            </div>
          </div>
        </section>
      )}

      <div className="sd-mb-10 sd-py-[2.5rem] sd-text-black sd-container sd-bg-[#F6F6F6] sd-items-center">
        <div className="sd-flex lg:sd-flex-row sd-flex-col sd-items-center sd-justify-center sd-gap-6 lg:sd-gap-12">
          {/* Region Dropdown */}
          <div className="sd-w-full selection">
            <div className="form-group">
              <div>
                <label htmlFor="region" className={`${regionClass} css-1q3955w`}>
                  {t("region")}
                </label>
                <div className={`select-dropdown select-dropdown-with-other select-redesign with-label sd-bg-[#FFF] ${regionClass}`}>
                  <select
                    className="validate requiredSelection inputHeight sd-text-base sd-w-full sd-border sd-border-black sd-px-4"
                    id="region"
                    aria-label="region dropdown"
                    tabIndex={0}
                    value={selectedRegion}
                    // onChange={onRegionChange}
                    onChange={(e) => {
                      setSelectedRegion(e.target.value);
                      setSelectedCountry("");
                      // setSelectedBrand("");
                      setSelectedReseller(""); // ✅ important
                    }}
                  >
                    <option value="">
                      {loadingRegions ? t("loadingregion") : t("selectregion")}
                    </option>
                    {[...new Set(regions.map((item) => item).filter(Boolean))]
                      .sort((a, b) => a.localeCompare(b))
                      .map((region) => (
                        <option key={region} value={region}>
                          {region}
                        </option>
                      ))}
                  </select>
                  <fieldset aria-hidden="true" className="css-1hisssc">
                    <legend className="css-w1u3ce">
                      <span>{t("region")}</span>
                    </legend>
                  </fieldset>
                </div>
              </div>
            </div>
          </div>

          {/* Country Dropdown */}
          <div className="sd-w-full selection">
            <div className="form-group">
              <div>
                <label htmlFor="country" className={`${regionClass} css-1q3955w`}>
                  {t("countryarea")}
                </label>
                <div className={`select-dropdown select-dropdown-with-other select-redesign with-label sd-bg-[#FFF] ${regionClass}`}>
                  <select
                    aria-label="country dropdown"
                    id="country"
                    className="sd-cursor-pointer sd-border sd-border-black sd-rounded-none sd-appearance-none sd-w-full sd-pl-2 sd-pr-20 sd-py-2"
                    value={selectedCountry}
                    onChange={(e) => setSelectedCountry(e.target.value)}
                  >
                    <option value="">
                      {loadingCountries
                        ? t("loadingcountryarea")
                        : t("selectcountryarea")}
                    </option>
                    {filteredCountries.map((country) => (
                      <option key={country} value={country}>
                        {country}
                      </option>
                    ))}
                  </select>
                  <fieldset aria-hidden="true" className="css-1hisssc">
                    <legend className="css-w1u3ce">
                      <span>{t("countryarea")}</span>
                    </legend>
                  </fieldset>
                </div>
              </div>
            </div>
          </div>

          {/* Brand Dropdown */}
          <div className="sd-w-full selection">
            <div className="form-group">
              <div>
                <label htmlFor="brand" className={`${regionClass} css-1q3955w`}>
                  {t("brand")}
                </label>
                <div className={`select-dropdown select-dropdown-with-other select-redesign with-label sd-bg-[#FFF] ${regionClass}`}>
                  <select
                    aria-label="brand dropdown"
                    id="brand"
                    className="sd-cursor-pointer sd-border sd-border-black sd-rounded-none sd-appearance-none sd-w-full sd-pl-2 sd-pr-20 sd-py-2"
                    value={selectedBrand}
                    onChange={(e) => {
                      setSelectedBrand(e.target.value);
                      // setSelectedCountry('');
                      setSelectedReseller("");
                    }}
                  >
                    <option value="">
                      {loadingBrands ? t("loadingbrand") : t("selectbrand")}
                    </option>
                    {brands
                      .filter(Boolean)
                      .sort((a, b) => a.localeCompare(b))
                      .map((brand) => (
                        <option key={brand} value={brand}>
                          {brand}
                        </option>
                      ))}
                  </select>
                  <fieldset aria-hidden="true" className="css-1hisssc">
                    <legend className="css-w1u3ce">
                      <span>{t("brand")}</span>
                    </legend>
                  </fieldset>
                </div>
              </div>
            </div>
          </div>
        </div>
        {(!loadingBrands && !loadingCountries && !loadingRegions) && <div className="sd-flex sd-flex-col sd-items-start sd-gap-3 sd-mt-[1.875rem]">
          {/* FILTER BY label */}
          {resellerTitles.length > 0 && <div className={`sd-titleText sd-text-[14px] sd-font-medium sd-font-pilat sd-tracking-[0.02em] sd-uppercase sd-flex sd-items-center ${regionClass}`}>
            {t("filterBy")}
          </div>}

          {/* Pills section */}
          <div className="sd-flex sd-flex-wrap sd-gap-4 sd-items-center">
            {[...resellerTitles]
              .sort((a, b) => a.localeCompare(b))
              .map((reseller, index) => {
                const isSelected = selectedReseller === reseller;

                return (
                  <label
                    tabIndex={0}
                    htmlFor={"for" + index}
                    key={index}
                    onKeyDown={(e) => {
                      if (e.key === "Enter" || e.key === " ") {
                        setSelectedReseller(reseller);
                      }
                    }}
                    className={`sd-cursor-pointer sd-outline-[#b58409] sd-uppercase hover:sd-bg-[#888] hover:sd-text-[#000] sd-rounded-full sd-py-4 sd-px-6 sd-text-sm sd-font-medium sd-flex sd-items-center
              ${
                isSelected
                  ? "!sd-bg-[#000] !sd-text-[#FFFFFF] sd-pointer-events-none "
                  : "sd-bg-[#E9E9E9] sd-text-[#000]"
              }`}
                  >
                    <input
                      type="radio"
                      id={"for" + index}
                      name="reseller"
                      value={reseller}
                      checked={isSelected}
                      onChange={() => setSelectedReseller(reseller)}
                      className="hidden"
                    />
                    {reseller}
                  </label>
                );
              })}
          </div>
        </div>}
      </div>

      {selectedReseller && selectedCountry && (
        <h2 className="sd-mt-[4rem] sd-text-2xl sd-font-medium sd-container sd-font-pilat sd-normal-case sd-mb-4">
          {selectedReseller}
        </h2>
      )}

      {selectedCountry && (
        <div className="sd-container sd-mb-8">
          <div className="sd-grid sd-grid-cols-1 sm:sd-grid-cols-2 md:sd-grid-cols-3 lg:sd-grid-cols-4 sd-gap-x-[39px] sd-gap-y-16">
            {[...filteredResults]
              .sort((a, b) =>
                (a.Name || "").localeCompare(b.Name || "", undefined, {
                  sensitivity: "base",
                })
              )
              .map((item, index) => (
                <div key={index} className="sd-flex sd-flex-col sd-h-full sd-table-footer-group">
                  {/* Card */}
                  <div className="sd-grid sd-grid-cols-1 sd-grid-rows-1 sd-w-full sd-h-[calc(100%-100px)] sd-min-h-[285px] sd-border sd-border-[#E6E6E6] sd-text-center sd-py-6 sd-px-6 sd-pr-0 sd-pl-0">
                    <div className="sd-w-full sd-flex sd-items-center sd-justify-center">
                      {item.Logo ? (
                        <img
                          src={item.Logo.Url}
                          alt={item.Title || "Reseller Logo"}
                          className="sd-max-h-full sd-px-[30px]"
                        />
                      ) : (
                        <div className="sd-font-medium sd-text-black sd-leading-none sd-word-break sd-text-[1.75rem] sd-px-2">
                          {item.Title || "No Title"}
                        </div>
                      )}
                    </div>

                    {(item.Address || item.Phone || item.Fax || item.Email) && (
                      <div className="sd-text-center sd-mt-2 sd-flex-1 sd-px-6 sd-w-fit sd-mx-auto">
                        {item.Address && (
                          <div className="sd-text-left"
                            dangerouslySetInnerHTML={{ __html: item?.Address }}
                          ></div>
                        )}
                        {item.Phone && (
                          <div className="sd-text-left">
                            Tel:{" "}
                            <span
                              dangerouslySetInnerHTML={{ __html: item?.Phone }}
                            ></span>
                          </div>
                        )}
                        {item.Fax && (
                          <div className="sd-text-left">
                            Fax:{" "}
                            <span
                              dangerouslySetInnerHTML={{ __html: item?.Fax }}
                            ></span>
                          </div>
                        )}
                        {item.Email && (
                          <div className="sd-text-left">
                            Email:{" "}
                            <a
                              href={`mailto:${item.Email}`}
                              className="sd-text-[#0072ef] hover:sd-cursor-pointer"
                            >
                              {item.Email}
                            </a>
                          </div>
                        )}
                      </div>
                    )}
                  </div>

                  {/* Link below card */}
                  <div className="sd-mt-4 sd-min-h-[22.5px] sd-h-fit sd-max-h-[120px]">
                    <a
                      href={
                        item.WebsiteURL?.Url ||
                        cardsDefaultUrl
                      }
                      target="_blank"
                      rel="noopener noreferrer"
                      className="sd-text-[#000] sd-font-[Pilat] sd-text-[18px] sd-font-medium sd-leading-[120%] sd-tracking-[0.36px]"
                      aria-label={item.Title}
                    >
                      {item.Title}
                    </a>
                  </div>
                </div>
              ))}
          </div>
        </div>
      )}

      {/* </div> */}
    </section>
  );
};

export default Distributors;
